import { styled } from "@stitches/react";
import SortAsc from "./sort-ascending";
import SortDesc from "./sort-descending";

const Wrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: 4,
});

const SortDefault = () => (
  <Wrapper>
    <SortAsc />
    <SortDesc />
  </Wrapper>
);

export default SortDefault;
